import { ToastSpace, useToast } from 'src/provider/ToastContextProvider'
import { createPortal } from 'react-dom'
import icon_logo from 'src/assets/images/logo/icon_logo.png'
import styled from 'styled-components'
import { Noto_body2_r14 } from 'src/styles/fonts/NotoSansKrFonts'

const Toast = () => {
  const { isOpen, closeToast, toastData } = useToast()
  const { when } = toastData
  const { contents } = toastData as ToastSpace.ToastData

  return createPortal(
    <S.ToastWrap $active={isOpen && (when as boolean)} onClick={closeToast}>
      <S.ToastLogo src={icon_logo} alt="logo" />
      <S.ToastText>{contents}</S.ToastText>
    </S.ToastWrap>,
    document.body,
  )
}

export default Toast
const S = {
  ToastWrap: styled.div<{ $active: boolean }>`
    max-width: 360px;
    width: calc(100% - 40px);
    padding: 10px 20px;
    gap: 8px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 100px;
    left: 50%;
    transform: translate(-50%, 0%);
    border-radius: 100px;
    background: var(--black-70, rgba(0, 0, 0, 0.7));
    transition: all 0.2s;
    opacity: ${(props) => (props.$active ? 1 : 0)};
    z-index: ${(props) => (props.$active ? 101 : -1)};
  `,
  ToastLogo: styled.img`
    width: 20px;
    height: auto;
  `,
  ToastText: styled.p`
    color: var(--white);
    ${Noto_body2_r14};
  `,
}
